<template>
  <div class="animated fadeIn list-of-po">
    <b-card>
      <div slot="header">Purchase/Service Order List
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button>
          <b-button variant="primary mr-1" @click="closeVoidConfirm" :disabled="disabledCloseVoid" >Close/Void</b-button>
          <b-button variant="primary mr-1" @click="statusUpdateConfirm" >Update Status</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Order No. (% for wildcard)"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Request Number &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.requestno" placeholder="Request No. (% for wildcard)"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Status &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.status" :plain="true" :options="approvalStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Outstand &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="outstandSlct"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.item" placeholder="Material/Service Name"></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined small 
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="rowVoid(data.item)" href="#" style="padding:0 !important;">Close/Void</b-dropdown-item>
          <b-dropdown-item @click="rowUpdate(data.item)" href="#" style="padding:0 !important;">Update Status</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#" style="padding:0 !important;">Attachment</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(status)="data">
          <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
            DRAFT
          </div>
          <div v-else> 
            <div v-if="data.item.iscomplete==0">           
              ON PROCESS
            </div>
            <div v-else>           
                <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                  APPROVED
                </div>
                <div v-else style="background-color:#f86c6b;">           
                  REJECTED
                </div>
            </div>
          </div>
        </template>

        <template v-slot:cell(nilainett)="data">
          {{data.item.nilainett | numFormat}}
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{data.item.nilaippn | numFormat}}
        </template>
        <template v-slot:cell(nilaidue)="data">
          {{data.item.nilaidue | numFormat}}
        </template>
        <template v-slot:cell(nilaiinv_po)="data">
          {{data.item.nilaiinv_po | numFormat}}
        </template>        
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
      <b-modal v-model="showStatusUpdate" header-bg-variant="primary"  title="Update Status Form" size="lg" :centered="true" @ok="statusUpdate" ok-title="Save">
              <b-row>
                  <b-col lg="6" xl="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="statusUpdateData.orderno" readonly :state="!$v.statusUpdateData.pohdrkey.$error"></b-form-input>
                  </b-input-group>
                  </b-col>
                  <b-col lg="6" xl="5">                            
                  <b-input-group>
                      <b-input-group-append><span class="input-group-text">Order Date</span></b-input-group-append>
                      <b-form-input v-model="statusUpdateData.orderdate" readonly></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-row >    
            <b-input-group>
                <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                <b-form-input v-model="statusUpdateData.vendorinfo" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Remark</label></b-input-group-prepend>
                <b-form-input v-model="statusUpdateData.remark" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Current Status</label></b-input-group-prepend>
              <b-form-input v-model="statusUpdateData.trackStatus" :state="!$v.statusUpdateData.trackStatus.$error"></b-form-input>
            </b-input-group>                
      </b-modal>

      <b-modal v-model="showCloseVoidConfirm" header-bg-variant="primary"  title="Close / Void - Form" size="lg" :centered="true" @ok="closeVoidProcess" ok-title="Save">
              <b-row>
                  <b-col lg="6" xl="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="closeVoidData.orderno" readonly :state="!$v.closeVoidData.pohdrkey.$error"></b-form-input>
                  </b-input-group>
                  </b-col>
                  <b-col lg="6" xl="5">                            
                  <b-input-group>
                      <b-input-group-append><span class="input-group-text">Order Date</span></b-input-group-append>
                      <b-form-input v-model="closeVoidData.orderdate" readonly></b-form-input>                                        
                  </b-input-group>
                  </b-col>
              </b-row >    
            <b-input-group>
                <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                <b-form-input v-model="closeVoidData.vendorinfo" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Remark</label></b-input-group-prepend>
                <b-form-input v-model="closeVoidData.remark" readonly></b-form-input>
            </b-input-group>
            <b-form-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Close / Void</label></b-input-group-prepend>
                  <b-form-radio-group v-model="closeVoidData.closeVoid" :options="closeVoidData.options" name="closevoidradios">
                  </b-form-radio-group>
                </b-input-group>                
              </b-col>
            </b-form-row>
            <b-input-group>
                <b-input-group-prepend><label>Close/Void Reasone</label></b-input-group-prepend>
                <b-form-textarea :rows="3" :max-rows="3" v-model="closeVoidData.closevoidnote" :state="!$v.closeVoidData.closevoidnote.$error" ></b-form-textarea>
            </b-input-group>
      </b-modal>
      
      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="5">
                  <b-input-group>
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.orderno" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="4">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.orderdate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
              <b-form-input v-model="model.vendorinfo"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" > 
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal
        v-model="showAttachment"
        header-bg-variant="primary"
        title="Attachment"
        size="lg"
        :centered="true"
        ok-only
      >
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Order Number</label></b-input-group-prepend
              >
              <b-form-input v-model="model.orderno" readonly></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="200px">Attached Date</th>
                <th>File Name</th>
                <th width="100px">Attached By</th>
                <th width="40px">action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in attachmens" :key="row.attachmentKey">
                <td>
                  {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>
                  <b-link @click="attachmentDownload(row)">{{
                    row.attchFileNm
                  }}</b-link>
                </td>
                <td>{{ row.createby }}</td>
                <td>
                  <div class="text-center" v-if="(model.isclosed || 0) == 0 && (model.isvoid || 0) == 0">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="delAttachment(row)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div no-body v-if="(model.isclosed || 0) == 0 && (model.isvoid || 0) == 0">
          <label>Add Attachment</label>
          <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-row class="mt-1" v-if="file">
            <span class="p-2"
              >Selected File:
              <strong>{{ file ? file.name : "" }}</strong> Filesize:{{
                bytesToKB.showFileSize(file)
              }}</span
            >
            <b-button
              variant="success"
              @click="attachmentSave"
              class="sm"
              ><i class="fa fa-paperclip"></i> Add Attachment</b-button
            >
          </b-row>
        </div>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .list-of-po {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   
  }

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../../apis/task";
import procure from "../../apis/procure";
import dropdown from "../../data/dropdown";
import bytesToKB from "../../libs/filesize-byte2kb";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading},
  mixins: [validationMixin],
  validations: {
        closeVoidData: {
            pohdrkey: { required },
            closevoidnote: { required }
        },
        statusUpdateData: {
            pohdrkey: { required },
            trackStatus: { required }
        },
  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      showCloseVoidConfirm:false,
      showAttachment: false,
      attachmens: [],
      bytesToKB,
      disabledCloseVoid:true,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
        items: [],
      tblData: {
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'orderdate',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:''
      },
      limit:15,
      pagination: false,
      model:{},
      postGroups:[],
      approvalStatus : dropdown.approvalStatus,
      outstandSlct : dropdown.openClose,
      closeVoidData:{
        closeVoid:'closed',
        closevoidnote:'',
        options: [
          { text: 'Closed', value: 'closed' },
          { text: 'Void', value: 'void' },
        ]
      },
      statusUpdateData:{trackStatus:''},
      showStatusUpdate:false,      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "orderno",
            thStyle: "width:100px",
            label: "Order Number",
            sortable: true
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "Order Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Requesition #",
            sortable: true
          },
          {
            key: "remark",
            thStyle: "width:300px",
            label: "Description",
          },
          {
            key: "status",
            label: "Approval status",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilainett",
            label: "Subtotal",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaippn",
            label: "VAT",
            thStyle: "width:90px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidue",
            label: "Total",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "invoiceno",
            label: "Invoiced AP",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nilaiinv_po",
            label: "Invoiced Amt.",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    invalidCloseVoidData() {
      this.$v.closeVoidData.$touch();
      return this.$v.closeVoidData.$invalid;
    },
    invalidStatusUpdateData() {
      this.$v.statusUpdateData.$touch();
      return this.$v.statusUpdateData.$invalid;
    },
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },
  created: async function(){
      const accList = await procure.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const now = new Date();
        // const tgl1 = moment(now).startOf('month').format('YYYY-MM-DD');
        // const tgl2 = moment(now).endOf('month').format('YYYY-MM-DD');
        // this.tblData.tgl1=this.tblData.tgl1 || tgl1;
        // this.tblData.tgl2=this.tblData.tgl2 || tgl2;
        // NOTE : DIRUBAH KE TANGGAL BERJALAN
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1=this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2=this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');

  },  
  methods: {
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.polist) {
            this.tblData[key] = filter.polist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.polist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.polist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await procure.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await procure.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.item=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.requestno=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status','outstand'];
      let filtered = false;
      const polist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              polist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          polist.page=this.tblData.page;
          polist.limit=this.tblData.limit;
          polist.sortBy=this.tblData.sortBy;
          polist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.polist=polist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowVoid(record) {
      this.rowClicked(record);
        this.closeVoidConfirm();        
    },
    rowUpdate(record) {
      this.rowClicked(record);
        this.showStatusUpdate();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.pohdrkey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (!this.file) {
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.model.pohdrkey);
          formData.append("tableName", "po_header");
          formData.append("filesize", bytesToKB.showFileSize(this.file));
          const response = await task.attachmentSave(formData);
          console.log("response : ", response);
          const data = await task.getAttachment({
            taskkey: this.model.pohdrkey,
          });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({
                taskkey: this.model.pohdrkey,
              });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    add(){
      this.saveFilter();
      router.push("order-form");
    },
    edit: function() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          router.push({name :'procurement.poinput', params: { pohdrkey: this.model.pohdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.pohdrkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await procure.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.pohdrkey==this.model.pohdrkey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    closeVoidConfirm() {
        if (this.model.pohdrkey) {
          this.showCloseVoidConfirm = true;
          // for (const key in this.model) {
          //   if (this.model.hasOwnProperty(key)) {
          //     this.closeVoidData[key] = this.model[key];
          //   }
          // }
          this.closeVoidData.pohdrkey=this.model.pohdrkey;
          this.closeVoidData.orderno=this.model.orderno;
          this.closeVoidData.orderdate=this.model.orderdate;
          this.closeVoidData.remark=this.model.remark;
          this.closeVoidData.vendorinfo=this.model.vendorinfo;

        } else {
            toastr.warn('Please select a row that want to be Closed / Void!');
        }
    },
    closeVoidProcess:async function(evt) {
      evt.preventDefault()
      if (this.invalidCloseVoidData) {
          console.log('validation : ', this.$v.model);
          console.log('model obj : ',this.model);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        if(this.closeVoidData.closeVoid === 'closed'){
          this.closeVoidData.isclosed = 1;
          this.closeVoidData.isvoid = 0;
        }else{
          this.closeVoidData.isclosed = 0;
          this.closeVoidData.isvoid = 1
        }
        this.closeVoidData.closevoiddate = (this.closeVoidData.closevoiddate) ? moment(this.closeVoidData.closevoiddate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        await procure.closevoid(this.closeVoidData);
        this.refresh();
      }
    },
    async statusUpdateConfirm() {
        // if (this.model.pohdrkey) {
          this.showStatusUpdate = true;
          this.statusUpdateData.pohdrkey=this.model.pohdrkey;
          this.statusUpdateData.orderno=this.model.orderno;
          this.statusUpdateData.orderdate=this.model.orderdate;
          this.statusUpdateData.remark=this.model.remark;
          this.statusUpdateData.vendorinfo=this.model.vendorinfo;

        // } else {
        //     toastr.warn('Please select a row that want to be Closed / Void!');
        // }
    },
    statusUpdate:async function(evt) {
      evt.preventDefault()
      if (this.invalidStatusUpdateData) {
          console.log('validation : ', this.$v.model);
          console.log('model obj : ',this.model);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        await procure.stausUpdate(this.stausUpdateData);
        this.refresh();
      }
    },
    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        this.disabledCloseVoid   = true;
      }

      // if (this.model.pohdrkey == record.pohdrkey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    approvalConfirm: async function () {
        if (this.model.pohdrkey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.pohdrkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.orderdate = this.model.orderdate ? moment(this.model.orderdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.pohdrkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await procure.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await procure.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.pohdrkey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    print: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await procure.print(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await procure.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'procurement.home'});
          router.push("home");
    }

  }
};
</script>
